export default "__VITE_ASSET__BeSah5lt__"